import { Routes, Route } from 'react-router-dom';
import { AppLayout } from 'common/Layout';
import {
  AdminPageProtector,
  ManagerPageProtector,
  AuthorizedPageProtector,
  UnauthorizedPageProtector,
} from 'common/Protectors';
import { homePageRoute } from './home/config';
import { notFoundPageRoute } from './404/config';
import { authorizationPageRoute } from './authorization/config';
import { regionsPageRoute } from './regions/config';
import { municipalitiesPageRoute } from './municipalities/config';
import { organizationsPageRoute } from './organizations/config';
import { logoutPageRoute } from './logout/config';
import { buildingPageRoute, buildingsPageRoute } from './buildings/config';
import { educationClassesPageRoute } from './educationClasses/config';
import { academicCalendarPageRoute } from './academicCalendar/config';
import { productionCalendarPageRoute } from './productionCalendar/config';
import {
  educationPlanOopPageRoute,
  educationPlanPageRoute,
  educationPlansPageRoute,
} from './educationPlans/config';
import { teacherWorkloadsPageRoute } from './teacherWorkloads/config';
import { teacherWorkloadPageRoute } from './teacherWorkload/config';
import { subjectDifficultiesPageRoute } from './subjectDifficulties/config';
import {
  configurationSchedulesPageRoute,
  scheduleConfigurationFormPageRoute,
  scheduleForWeekPageRoute,
  schedulePageRoute,
} from './schedule-for-week/config';
import { bellSchedulesPageRoute } from './bellSchedules/config';
import { maxLessonsPerDayPageRoute } from './maxLessonsPerDay/config';
import { classGroupsPageRoute } from './classGroups/config';

export const AppRouting = () => {
  return (
    <Routes>
      <Route element={<AuthorizedPageProtector />}>
        <Route element={<AppLayout />}>
          <Route path={homePageRoute.path} element={homePageRoute.element} />
          <Route element={<AdminPageProtector />}>
            <Route path={regionsPageRoute.path} element={regionsPageRoute.element} />
            <Route path={municipalitiesPageRoute.path} element={municipalitiesPageRoute.element} />
            <Route path={organizationsPageRoute.path} element={organizationsPageRoute.element} />
            <Route
              path={subjectDifficultiesPageRoute.path}
              element={subjectDifficultiesPageRoute.element}
            />
          </Route>
          <Route element={<ManagerPageProtector />}>
            <Route path={buildingsPageRoute.path} element={buildingsPageRoute.element} />
            <Route path={buildingPageRoute.path} element={buildingPageRoute.element} />
            <Route
              path={educationClassesPageRoute.path}
              element={educationClassesPageRoute.element}
            />
            <Route
              path={academicCalendarPageRoute.path}
              element={academicCalendarPageRoute.element}
            />
            <Route
              path={productionCalendarPageRoute.path}
              element={productionCalendarPageRoute.element}
            />
            <Route path={educationPlansPageRoute.path} element={educationPlansPageRoute.element} />
            <Route path={educationPlanPageRoute.path} element={educationPlanPageRoute.element} />
            <Route
              path={scheduleForWeekPageRoute.path}
              element={scheduleForWeekPageRoute.element}
            />
            <Route
              path={scheduleConfigurationFormPageRoute.path}
              element={scheduleConfigurationFormPageRoute.element}
            />
            <Route
              path={configurationSchedulesPageRoute.path}
              element={configurationSchedulesPageRoute.element}
            />
            <Route path={schedulePageRoute.path} element={schedulePageRoute.element} />
            <Route
              path={educationPlanOopPageRoute.path}
              element={educationPlanOopPageRoute.element}
            />
            <Route
              path={teacherWorkloadsPageRoute.path}
              element={teacherWorkloadsPageRoute.element}
            />
            <Route
              path={teacherWorkloadPageRoute.path}
              element={teacherWorkloadPageRoute.element}
            />
            <Route path={bellSchedulesPageRoute.path} element={bellSchedulesPageRoute.element} />
            <Route
              path={maxLessonsPerDayPageRoute.path}
              element={maxLessonsPerDayPageRoute.element}
            />
            <Route path={classGroupsPageRoute.path} element={classGroupsPageRoute.element} />
          </Route>
        </Route>
        <Route path={logoutPageRoute.path} element={logoutPageRoute.element} />
      </Route>
      <Route element={<UnauthorizedPageProtector />}>
        <Route
          element={
            <AppLayout visibleSidebar={false} visibleHeader={false} visibleWelcomeSidebar={true} />
          }
        >
          <Route path={authorizationPageRoute.path} element={authorizationPageRoute.element} />
        </Route>
      </Route>
      <Route element={<AppLayout visibleSidebar={false} />}>
        <Route path={notFoundPageRoute.path} element={notFoundPageRoute.element} />
      </Route>
    </Routes>
  );
};
